import React from "react";
import { Link } from "react-router-dom";
import Hospitals from "../../assets/Hospitals.png";
import Labs from "../../assets/Laboratories.png";
import Pharmacies from "../../assets/Pharmacies.png";
import {
  Container,
  CardContainer,
  Card,
  Image,
} from "../../styles/home/featured";

const Featured = () => {
  return (
    <>
      <Container>
        <h1>Featured providers</h1>
        <CardContainer>
          <Card>
            <Link to="/search/Hospitals">
              <Image src={Hospitals} alt="Hospitals and clinic" />
              <p>Hospitals and clinics</p>
            </Link>
          </Card>
          <Card>
            <Link to="/comingsoon">
              <Image src={Labs} alt="Labs" />
              <p>Laboratories</p>
            </Link>
          </Card>
          <Card>
            <Link to="/comingsoon">
              <Image src={Pharmacies} alt="Pharmacies" />
              <p>Pharmacies</p>
            </Link>
          </Card>
        </CardContainer>
      </Container>
    </>
  );
};

export default Featured;
